const paraguay = {
  tenant: process.env.REACT_APP_PY_TENANT,
  env: process.env.REACT_APP_PY_ENV,
  sicfeBaseUrl: process.env.REACT_APP_PY_SICFE_BASE_URL,
};

export default paraguay;
